import React from 'react';
import { Badge } from 'react-bootstrap';
import CloseButton from './CloseButton';
import { dragAndDropFunctions } from './Functions';

function DraggableFilter({ filter, onRemove, className }) {
    const filterType = filter?.filterType ?? className ?? '';
    const filterText = filter?.filterText ?? '';

    function handleDragStart(ev) {
        ev.dataTransfer.setData('text/filter', JSON.stringify(filter));
        ev.dataTransfer.effectAllowed = 'move';
        dragAndDropFunctions.startDrag(
            ev,
            filterType,
            filter?.granularity != null ? [filter.granularity] : [],
            filter?.statId ?? null
        );
        ev.stopPropagation();
    }

    return (
        <Badge
            className={`draggable ${filterType}`}
            id={filter?.id ?? ''}
            style={{ margin: '5px' }}
            variant='secondary'
            draggable='true'
            onDragStart={handleDragStart}
            onDragEnd={dragAndDropFunctions.endDrag}
        >
            {filterText}
            <CloseButton onRemove={onRemove} />
        </Badge>
    );
}

export default DraggableFilter;